// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"638":"3f6a70d2","703":"5e5b4c22","968":"9e8b8f78"}[chunkId] + ".chunk.js";
};